import * as React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { lighten } from "@material-ui/core/styles/colorManipulator";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import { User, Report, Tag } from "../../api/classes";
import { Link } from "react-router-dom";
import * as routes from "../../routes";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem } from "@material-ui/core";
import MoreSettings from "../../components/more";
import { render } from "react-dom";
import EditTag from "./edit";
import ApproveDialog from "../../components/dialogs/approveDialog";
import EmptyState from "src/components/emptyState";
import { GlobalState } from "src/store";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { DubitoSvc } from "src/api";
import { hasPermissionOf } from "src/auth/auth";
import { Permissions } from "src/api/constants";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      textAlign: "center"
      //   paddingTop: theme.spacing.unit * 20
    }
  });

type State = {
  open: boolean;
};
const styles1 = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  }
});

interface Props {
  classes: any;
  elements: Tag[];
  fetchTags: () => void;
}
class TagTable extends React.Component<Props> {
  state = {
    element: undefined,
    editOpen: false,
    deleteOpen: false
  };
  openAddTag = () => {
    this.setState({ editOpen: true, deleteOpen: false, element: undefined });
  };
  openDeleteTag = () => {
    this.setState({ editOpen: false, deleteOpen: true, element: undefined });
  };
  closeDeleteTag = () => {
    this.setState({ editOpen: false, deleteOpen: false, element: undefined });
  };
  deleteTag = () => {
    DubitoSvc.deleteTag({ tag_id: this.state.element.id }).then(() => {
      this.props.fetchTags();
      // this.props
      this.closeDeleteTag();
    });
  };
  renderEditAndDelete() {
    return (
      <>
        <EditTag
          element={this.state.element}
          open={this.state.editOpen}
          onCancel={this.closeDeleteTag}
          onEdit={() => {
            this.setState({ editOpen: false });
            this.props.fetchTags();
          }}
        />
        {this.state.element && (
          <ApproveDialog
            title={this.state.element.title}
            description={
              "Do you really want to delete " +
              this.state.element.title +
              " tag?"
            }
            open={this.state.deleteOpen}
            onApprove={this.deleteTag}
          />
        )}
      </>
    );
  }
  render() {
    const { classes, elements } = this.props;
    const canEdit = hasPermissionOf(Permissions.EDIT_TAGS);
    return (
      <Paper className={classes.root}>
        {this.renderEditAndDelete()}
        <Toolbar>
          <div className={classes.title}>
            <Typography variant="title" id="tableTitle">
              Tags
            </Typography>
          </div>
          <div className={classes.spacer} />
          {canEdit && (
            <div className={classes.actions}>
              <Tooltip title="Add Tag">
                <IconButton onClick={this.openAddTag} aria-label="Add Tag">
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
        </Toolbar>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Case Count</TableCell>
              <TableCell>Created At</TableCell>
              {canEdit && <TableCell />}
            </TableRow>
          </TableHead>
          <TableBody>
            {elements &&
              elements.map((row: Tag) => {
                return (
                  <TableRow key={row.id}>
                    <TableCell>{row.id}</TableCell>
                    <TableCell>
                      <Link
                        to={routes.PATH_CASES + "?tag=" + row.title}
                        style={{ textDecoration: "none" }}
                      >
                        {row.title}
                      </Link>{" "}
                    </TableCell>
                    <TableCell> {row.case_count} </TableCell>
                    <TableCell> {row.created_at}</TableCell>
                    {canEdit && (
                      <TableCell>
                        <MoreSettings
                          options={[
                            {
                              label: "Edit",
                              onClick: () => {
                                this.setState({ editOpen: true, element: row });
                              }
                            },
                            {
                              label: "Delete",
                              onClick: () => {
                                this.setState({
                                  deleteOpen: true,
                                  element: row
                                });
                              }
                            }
                          ]}
                        />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        {!elements ||
          (elements.length === 0 && (
            <div style={{ paddingBottom: 72 }}>
              <EmptyState message="There is no tag yet. You may create one by pressing + icon at the top." />
            </div>
          ))}
      </Paper>
    );
  }
}

export default connect(
  (state: GlobalState, own: any) => ({}),
  dispatch => ({
    fetchTags: (): any => dispatch(actions.fetchTags())
  })
)(withStyles(styles)(TagTable));



// WEBPACK FOOTER //
// ./src/pages/tags/table.tsx